<template>
  <div>
    <div class="col-md-12 mt-4 mb-4">
      <div class="d-flex flex-column  custom-border">
      </div>
    </div>
    <div
      class="d-flex align-items-center cursor-pointer icon-container "
      v-b-toggle="'structure-form-' + structureId"
    >
      <div class="icon-wrapper">
        <transition name="fade">
          <b-icon-caret-down-fill  v-if="isOpen" key="down" class="icon"></b-icon-caret-down-fill>
          <b-icon-caret-right-fill  v-else key="right" class="icon"></b-icon-caret-right-fill>
        </transition>
      </div>
      <div class="bold-text profil-subsection">{{ $t('Profile.structure.data')+' '+ structureName}}</div>
    </div>

    <b-collapse :id="'structure-form-' + structureId" v-model="isOpen">
      <div class="d-flex flex-column">
        <b-form @submit.stop.prevent="onSubmit">
          <div class="row mt-4">
            <div class=col-md-6>
              <b-form-group
                :invalid-feedback="form.structureName.invalidFeedback"
                :label="$t('structure.name')"
                :state="form.structureName.state"
                class="medium-label mb-4"
                label-for="addressDetails-input">
                <b-form-input
                  id="addressDetails-input"
                  v-model="form.structureName.value"
                  :state="form.structureName.state"
                  required
                  tabindex="9"
                  v-on:change="removeInvalidFeedback('structureName'); askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class=col-md-6>
              <b-form-group
                :invalid-feedback="form.address.invalidFeedback"
                :label="$t('structure.address')"
                :state="form.address.state"
                class="medium-label mb-4"
                label-for="address-input">
                <b-form-input
                  id="address-input"
                  v-model="form.address.value"
                  :state="form.address.state"
                  required
                  tabindex="5">
                </b-form-input>
              </b-form-group>
            </div>

            <div class=col-md-6>
              <b-form-group
                :invalid-feedback="form.addressDetails.invalidFeedback"
                :label="$t('structure.address.details')"
                :state="form.addressDetails.state"
                class="medium-label mb-4"
                label-for="addressDetails-input">
                <b-form-input
                  id="addressDetails-input"
                  v-model="form.addressDetails.value"
                  :state="form.addressDetails.state"
                  tabindex="6">
                </b-form-input>
              </b-form-group>
            </div>

            <div class=col-md-6>
              <b-form-group
                :invalid-feedback="form.postalCode.invalidFeedback"
                :label="$t('structure.postalCode')"
                :state="form.postalCode.state"
                class="medium-label mb-4"
                label-for="postalCode-input">
                <b-form-input
                  id="postalCode-input"
                  v-model="form.postalCode.value"
                  :state="form.postalCode.state"
                  required
                  tabindex="7">
                </b-form-input>
              </b-form-group>
            </div>

            <div class=col-md-6>
              <b-form-group
                :invalid-feedback="form.city.invalidFeedback"
                :label="$t('structure.city')"
                :state="form.city.state"
                class="medium-label mb-4"
                label-for="city-input">
                <b-form-input
                  id="city-input"
                  v-model="form.city.value"
                  :state="form.city.state"
                  required
                  tabindex="8">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button tabindex="2" type="submit" variant="primary">{{$t('Validate')}}</b-button>
          </div>
        </b-form>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import DropdownDepartment from "../../../components/b122/DropdownDepartment";
import api from "../../../services/api";
export default {
  name: "MineStructureEdit",

  components:{
    DropdownDepartment
  },

  props:{
    structureId:Number,
    structureName:String,
  },
  data() {
    return {
      isOpen: false,
      departments: [],
      askConfirm: false,
      form: {
        structureName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        addressDetails:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      isLoading:true,
      structure:{}
    };
  },

  emits: ['structureUpdated'],

  watch: {
    async isOpen(newVal) {
      if (newVal) {
        this.isLoading = true
        await this.fetchStructure()
        this.isLoading = false
      }
    }
  },

  methods:{

    async fetchStructure(){
      this.isLoading=true
      api
        .get(`/structure/getStructureProfile/`+this.structureId)
        .then(response => {
          this.structure=response.data
          this.setInitialValues()

        })
        .catch((error) => {
          this.isOpen=false
        })
    },

    setInitialValues () {
      if (this.structure != null) {
        this.form.structureName.value = this.structure.structureName
        this.form.address.value = this.structure.address
        this.form.addressDetails.value = this.structure.addressDetails !== 'null' ? this.structure.addressDetails : null
        this.form.postalCode.value = this.structure.postalCode
        this.form.city.value = this.structure.city
      }
    },

    async onSubmit () {
      let data = new FormData()
      if(!this.structureId){
        this.isOpen=false
        return
      }
      data.append('id', String(this.structureId))
      data.append('structureName', this.form.structureName.value)
      data.append('address', this.form.address.value)
      data.append('addressDetails', this.form.addressDetails.value)
      data.append('postalCode', this.form.postalCode.value)
      data.append('city', this.form.city.value)

      await api({
        method: 'post',
        url: '/structure/updateStructureProfile',
        data:data
      })
        .then((response) => {
          this.isOpen=false
          this.structure=response.data
          this.$nextTick(() => {
            this.successToast(this.structure.structureName)
          })
          this.$emit('structureUpdated',{ id: this.structureId, tostring: this.structure.structureName })
        })
        .catch((error) => {
          if(error.response.status === 403){
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
          else{
            this.isOpen=false
          }
        })
    },

    successToast (taskName) {
      this.$bvToast.toast(this.$i18n.t('Structure') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },
    removeInvalidFeedback (field) {
      this.form[field]['state'] = null
    },
  },
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.icon-container {
  position: relative;
}

.icon-wrapper {
  position: relative;
  width: 24px; /* Ajustez la largeur en fonction de la taille de l'icône */
  height: 14px;
}

.icon {
  position: absolute;
  top: 0;
  left: 0;
}
</style>





// WEBPACK FOOTER //
// src/views/user/profileEdit/MineStructureEdit.vue